import MessageAlert from "@/views/commons/utilities/MessageAlert.vue"

const ModalPlugin = {
    install(Vue, options) {
        const modalInstances = []
        Vue.prototype.$MessageAlert = function (propsData = {}) {
            modalInstances.forEach((instance) => {
                instance.close()
            })
            const ModalComponentConstructor = Vue.extend(MessageAlert)
            const modalInstance = new ModalComponentConstructor({
                propsData: {
                    ...options,
                    ...propsData,
                },
            })
            modalInstances.push(modalInstance)
            modalInstance.$mount()
            document.body.appendChild(modalInstance.$el)
        }
        Vue.prototype.$MessageAlert.closeAll = function () {
            modalInstances.forEach((instance) => {
                instance.close()
            })
        }
    },
}

export default ModalPlugin
